import { render, staticRenderFns } from "./VltInputCustom.vue?vue&type=template&id=fac65d1c&"
import script from "./VltInputCustom.vue?vue&type=script&lang=js&"
export * from "./VltInputCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports